import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import ITokenData from "../data/ITokenData";

export default class TokenDataParser implements IBaseDataParser<ITokenData> {
    check(data) {
        // Allow parse only if we have a sessionId and playerToken.
        return data?.data?.sessionId && data?.data?.playerToken
    }

    parse(data): ITokenData {
        return {
            // Will set GameModel.playerToken property.
            playerToken: data.data.playerToken
        };
    }
}
